export { default } from './inlineloader.js'



// WEBPACK FOOTER //
// ./src/modules/common/components/inlineloader/index.js